import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { copyFontFamily, copyFontSizeSmall, formLabelColor, formLabelSize, token } from '@nib-components/theme';
import { disabledOpacity } from '../disabled';
// eslint-disable-next-line
const Label = styled(_ref => {
  let {
    isCompact,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("label", {
    "data-mesh-component": "FORM-CONTROL--LABEL",
    ...rest
  });
})`
  display: block;
  color: var(--themeColorFgLabel, ${formLabelColor});
  font-family: ${token('formControl.typography.label.fontFamily', copyFontFamily)};
  font-size: ${token('formControl.typography.label.fontSize', formLabelSize)};
  font-weight: ${token('formControl.typography.label.fontWeight', 700)};
  line-height: ${token('formControl.typography.label.lineHeight', 1.5)};
  letter-spacing: ${token('formControl.typography.label.letterSpacing')};
  text-transform: ${token('formControl.typography.label.textTransform')};
  width: 100%;

  ${_ref2 => {
  let {
    isCompact
  } = _ref2;
  return isCompact && css`
      font-size: ${token('theme.typography.copy.small.fontSize', copyFontSizeSmall)};
    `;
}};

  ${_ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled && css`
      opacity: ${disabledOpacity};
    `;
}};
`;
Label.displayName = 'Label';
export default Label;